import { Navigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../pages/AuthContext';

const PrivateRoute = ({ children, requiredRole = null }) => {
    const [isChecking, setIsChecking] = useState(true);
    const { isLogged, userRole } = useContext(AuthContext);

    useEffect(() => {
        // Simulate checking auth status
        const checkAuth = () => {
            setTimeout(() => {
                setIsChecking(false);
            }, 100);
        };
        checkAuth();
    }, []);

    if (isChecking) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-secondary"></div>
            </div>
        );
    }

    if (!isLogged) {
        return <Navigate to="/login" />;
    }

    if (requiredRole && userRole !== requiredRole) {
        return <Navigate to="/" />;
    }

    return children;
};

export default PrivateRoute; 